import CategoryIcon from "@mui/icons-material/Category";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import BoltIcon from "@mui/icons-material/Bolt";
import { FilterList, FilterListItem, FilterLiveSearch, SavedQueriesList } from "react-admin";
import { StyledListAside } from "@/components/ui/react-admin/StyledListAside";

export const TaskTemplateListAside = () => {
  return (
    <StyledListAside>
      <FilterLiveSearch />
      <SavedQueriesList />

      <FilterList label="Status" icon={<ToggleOnIcon />}>
        <FilterListItem label="Active" value={{ is_active: true }} />
        <FilterListItem label="Inactive" value={{ is_active: false }} />
      </FilterList>

      <FilterList label="Category" icon={<CategoryIcon />}>
        <FilterListItem label="Threshold Monitoring" value={{ template_category: "Threshold Monitoring" }} />
        <FilterListItem label="Data Quality" value={{ template_category: "Data Quality" }} />
      </FilterList>

      <FilterList label="Trigger Event" icon={<BoltIcon />}>
        <FilterListItem label="50% Threshold" value={{ trigger_event: "threshold_50_percent" }} />
        <FilterListItem label="85% Threshold" value={{ trigger_event: "threshold_85_percent" }} />
        <FilterListItem label="100% Threshold" value={{ trigger_event: "threshold_100_percent" }} />
        <FilterListItem label="ICD Trigger" value={{ trigger_event: "icd_trigger_detected" }} />
        <FilterListItem label="Claim Update" value={{ trigger_event: "stoploss_claim_update" }} />
        <FilterListItem label="Prompt Pay" value={{ trigger_event: "prompt_pay_required" }} />
        <FilterListItem label="Placeholder Client" value={{ trigger_event: "placeholder_client_created" }} />
        <FilterListItem label="Placeholder Policy" value={{ trigger_event: "placeholder_policy_created" }} />
      </FilterList>
    </StyledListAside>
  );
};
